// extracted by mini-css-extract-plugin
export default {"root":"SearchModuleDestination_root__cQSXZ","sticky-destination":"SearchModuleDestination_sticky-destination__Eb4kt"};